import { render } from "./TheSales.vue?vue&type=template&id=3fcea6f0&scoped=true&lang=true"
import script from "./TheSales.vue?vue&type=script&lang=js"
export * from "./TheSales.vue?vue&type=script&lang=js"

import "./TheSales.vue?vue&type=style&index=0&id=3fcea6f0&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcea6f0"]])

export default __exports__